import React from "react";

import css from "./Section.module.css";

import cn from "classnames";

type SectionProps = {
    title: string | React.ReactNode;
    classNames?: { content?: string };
};

export const Section: React.FC<React.PropsWithChildren<SectionProps>> = ({
    title,
    children,
    classNames,
}) => {
    return (
        <div className={css.main}>
            <div className={cn(css.title, "typography-subtitle")}>{title}</div>
            <div className={cn(css.content, classNames?.content)}>{children}</div>
        </div>
    );
};
